var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex justify-flex-start align-center w-full" },
    [
      _c(
        "div",
        { staticClass: "mr-3 mt-3", staticStyle: { width: "32%" } },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "Email",
              tag: "div",
              vid: _vm.emailFieldName,
              immediate: _vm.immediate,
              rules: _vm.customRules,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        placeholder: "Enter email",
                        errors: _vm.getErrors(errors, changed),
                        value: _vm.localEmail,
                        processing: _vm.processing,
                        name: _vm.emailFieldName,
                        debounceTime: 500,
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleEmailUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.emailFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.emailFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mr-3 mt-3", staticStyle: { width: "32%" } },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "First name",
              rules: "required_field|c_name",
              tag: "div",
              vid: _vm.nameFieldName,
              immediate: _vm.immediate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        name: "csv_item_given_name",
                        placeholder: "Enter first name",
                        value: _vm.userGivenName,
                        errors: _vm.validateCsv || changed ? errors : [],
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleGivenNameUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.firstNameFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.firstNameFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mr-3 mt-3", staticStyle: { width: "32%" } },
        [
          _c("ValidationProvider", {
            attrs: {
              name: "Last name",
              rules: "required_field|c_name",
              tag: "div",
              vid: _vm.surnameFieldName,
              immediate: _vm.immediate,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors, changed }) {
                  return [
                    _c("FormGroup", {
                      attrs: {
                        formInputClass: _vm.animationClass,
                        name: "csv_item_family_name",
                        placeholder: "Enter last name",
                        value: _vm.userFamilyName,
                        errors: _vm.validateCsv || changed ? errors : [],
                        disabled: !_vm.allowedAdding,
                      },
                      on: { input: _vm.handleFamilyNameUpdate },
                      scopedSlots: _vm._u(
                        [
                          _vm.lastNameFieldTitle
                            ? {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "required-icon" },
                                      [_vm._v("*")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.lastNameFieldTitle)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { class: _vm.animationClass, staticStyle: { width: "5%" } }, [
        _c(
          "button",
          {
            staticClass:
              "block h-5 w-5 h-12 mb-2 text-gray-400 hover:text-gray-500 focus:outline-none disabled:text-gray-300",
            class: _vm.deleteButtonStyles,
            attrs: {
              type: "button",
              id: "userInvitation",
              disabled: !_vm.allowDelete,
            },
            on: { click: _vm.handleRemoveClick },
          },
          [_c("CrossIconBlack")],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }